import { t } from 'i18next'

import ThumbVideoZoomable from '~/components/ThumbVideoZoomable'
import ThumbZoomable from '~/components/ThumbZoomable'

export const schemaSponsoredBrand: SchemaMediaReviewItems = {
  assets: {
    title: t('rm:adReview.list.contentCampaign'),
    render: data => (
      <div className="mainInfo">
        <strong className="brand_name">
          {t('rm:campaign.create.SponsoredBrand.elements.brandName')}
        </strong>
        : {data?.campaign_settings?.brand_name || '-'}
        <br />
        <strong className="title">
          {t('rm:campaign.create.SponsoredBrand.elements.title')}
        </strong>
        : {data?.campaign_settings?.headline || '-'}
        <br />
        <strong className="description">
          {t('rm:campaign.create.SponsoredBrand.elements.description')}
        </strong>
        : {data?.campaign_settings?.description || '-'}
      </div>
    )
  },
  logo: {
    title: t('rm:campaign.create.SponsoredBrand.FieldsetLogo.label'),
    render: data => (
      <img
        src={data.campaign_settings.brand_url}
        alt={data.campaign_settings.brand_name}
        style={{ maxWidth: '320px' }}
      />
    )
  },
  mainInfo: {
    title: t('rm:adReview.list.title'),
    render: data => (
      <div className="asseets d-flex align-items-center gap-2">
        {data.campaign_settings.assets?.map(asset =>
          asset.type === 'image' ? (
            <ThumbZoomable key={asset.url} url={asset.url} title={asset.type} />
          ) : (
            <ThumbVideoZoomable
              key={asset.url}
              url={asset.url}
              title={asset.type}
            />
          )
        )}
      </div>
    )
  }
}
